import './index.css';
import { Col, Row } from 'react-bootstrap';
import useRegisterStep2 from './hooks/useRegisterStep2';
import PasswordAndConfirm from '@Components/Password';
import { Text } from '@Components/Text';
import { ErrorText, SubTitle, SubTitleBlue, TextLink } from '../styled';
import { ContainerRegister } from '../RegisterStep1/styled';

const RegistrationViewStep2 = () => {
	const {
		loading,
		intl,
		hasErrors,
		handleSubmit,
		formik,
		HandleValidate2,
		setLoading,
	} = useRegisterStep2();

	return (
		<ContainerRegister>
			<form
				className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
				id="kt_login_signup_form"
				onSubmit={handleSubmit}
			>
				{/* begin::Heading */}
				<Row className=" mb-5 ">
					<Col className="d-flex justify-content-center ">
						<Text weight="semi-bold">
							{intl.formatMessage({ id: 'AUTH.REGISTER.STEP2.1' })}
						</Text>
					</Col>
				</Row>
				{/* 
			{/* begin::Form group Password */}
				<PasswordAndConfirm formik={formik} />
				{/* end::Form group */}

				{/* begin::Form group */}
				<div className="fv-row mb-10 ">
					<div className="d-flex align-items-center  form-check form-check-custom form-check-solid">
						<input
							className="form-check-input"
							type="checkbox"
							id="kt_login_toc_agree"
							{...formik.getFieldProps('acceptTerms')}
						/>
						<label
							className=" d-flex align-items-center ms-2"
							htmlFor="kt_login_toc_agree"
						>
							<TextLink>
								{intl.formatMessage({ id: 'AUTH.REGISTER.STEP2.6' })}{' '}
							</TextLink>
							<a href="https://e-valuados.com/terminos-y-condiciones/">
								<SubTitleBlue className="mt-0 mb-0">
									{intl.formatMessage({ id: 'AUTH.REGISTER.STEP2.7' })}
								</SubTitleBlue>
							</a>
						</label>
					</div>
					{formik.touched.acceptTerms && formik.errors.acceptTerms && (
						<ErrorText>
							{intl.formatMessage({ id: formik.errors.acceptTerms })}
						</ErrorText>
					)}
				</div>

				{/* begin::Form group */}
				<div className="text-center">
					{!formik.isValid || !formik.values.acceptTerms ? (
						<button
							id="kt_sign_up_submit"
							className="d-flex bg-light border rounded justify-content-center align-items-center step-custom fw-bolder w-100 cursor-normal  m-auto"
							onClick={HandleValidate2}
						>
							<span className="indicator-label">
								{intl.formatMessage({ id: 'BTN.CREATEACOUNT' })}
							</span>
						</button>
					) : (
						<button
							type="submit"
							onClick={() => setLoading(true)}
							className="btn btn-lg btn-primary w-100 mb-5"
						>
							{!loading && (
								<span className="indicator-label">
									{intl.formatMessage({ id: 'BTN.CREATEACOUNT' })}
								</span>
							)}
							{loading && (
								<span
									className="indicator-progress"
									style={{ display: 'block' }}
								>
									{intl.formatMessage({ id: 'AUTH.REGISTER.STEP1.16' })}{' '}
									<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
								</span>
							)}
						</button>
					)}
				</div>
				{/* end::Form group */}
			</form>
		</ContainerRegister>
	);
};

export default RegistrationViewStep2;
